import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import colors from '../styles/colors';
import { GET_CURRENT_ORGANIZATION } from '../graphql/queries';
import Error from './Error';
import { FadeIn } from './Animation';
import EnterPayment from './EnterPayment';
import ChangePayment from './ChangePayment';
import Loader from './Loader';
import { media } from '../util/MediaQuery';

const Content = styled.div`
  text-align: center;
  align-items: center;
  justify-content: center;
`;
const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${colors.white};

  border-radius: 5px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: auto;
  overflow-y: auto;
  ${media.desktop`
    &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
    padding: 30px;
    width: 400px;
  `};

  ${media.mobile`
    height: 100vh;
    width: 100vw;
    padding: 10px;
  `};
  ${media.desktop`
    min-height: 85vh !important;
    max-height: 85vh !important; 
  `};
  ${media.tablet`
    min-height: 100vh;
    max-height: 100vh; 
  `};
`;

const Body = styled.div`
  /* display: flex;
  flex: 1;
  width: 100%; */
`;

const LoaderContainer = styled.div`
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BodyText = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey2};
  margin-bottom: 30px;
  line-height: 21px;
`;

const TopText = styled.div`
  font-size: 2rem;
  text-align: center;
  padding-bottom:10px;
`;

function EnterPaymentPage() {
  const history = useHistory();
  const [error, setError] = useState('');
  const { data, loading, refetch} = useQuery(GET_CURRENT_ORGANIZATION);

  useEffect(() => {
    refetch();
  }, []); 

  if (loading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  // if the user is a previous customer just update the card.
  // otherwise create a new stripe account.
  const isPreviousCustomer = data?.getCurrentOrganization?.subscriptionId;
  const bodyText = isPreviousCustomer
    ? 'Please update your payment information to continue using Check This Out. If you have an outstanding balance, you will be charged.'
    : 'You will be charged an immediate $299.00 onboarding fee.';

   
  return (
    <Content>
      <ContentWrapper>
        <FadeIn duration={0.6}>
          <TopText >Enter your payment information.</TopText>
          <BodyText>{bodyText}</BodyText>
          <BodyText>
            Check This Out will charge your credit card $.30 for every $1 of
            discount activated and for agreed upon fees for professional
            services automatically every month.
          </BodyText>
          <BodyText>
            All accounts will be charged a minimum monthly fee of $99 that will
            be credited towards campaign fees and word-of-mouth engine fees
            incurred each 30 day period.
          </BodyText>
         <Body>
            {isPreviousCustomer ? (
              <ChangePayment
                setError={setError}
                onCompleted={() => {
                  history.push('/dashboard');
                }}
              />
            ) : (
              <EnterPayment
                setError={setError}
                onCompleted={() => {
                  history.push('/dashboard');
                }}
              />
            )}
            {error && <Error error={error} margin="20px 0px 0px 0px" />}
          </Body>
        </FadeIn>
      </ContentWrapper>
    </Content>
  );
}

export default EnterPaymentPage;
